/**
 * shadcn/ui NativeSelect on the brand tokens: a real <select> under a styled shell.
 *
 * Author: Mahmoud Ragab Ahmed.
 *
 * Chosen over the Radix Select for forms on purpose: on a phone, in gloves, the operating
 * system's own picker is the larger and surer target, and the control stays a <select>
 * for every test and every assistive technology that already knows one.
 */
import { ChevronDown } from "lucide-react";

import { fieldControl } from "./input";
import { cn } from "@/lib/utils";

export function NativeSelect({
  className,
  ...props
}: React.ComponentProps<"select">): React.JSX.Element {
  return (
    <div data-slot="native-select-wrapper" className="relative w-full">
      <select
        data-slot="native-select"
        className={cn(fieldControl, "min-h-11 appearance-none py-2 pe-9", className)}
        {...props}
      />
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute end-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </div>
  );
}
